import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "../ui/dialog";
import { Button } from "../ui/button";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { ContactFields } from "./ContactFields";
import { handoverApi } from "./handoverApi";

const EMPTY = { company_name: "", name: "", email: "", mobile: "" };

export const DeveloperDialog = ({ open, onOpenChange, siteId, developer, onSaved }) => {
  const [form, setForm] = useState(EMPTY);
  const [saving, setSaving] = useState(false);

  useEffect(() => { if (open) setForm(developer ? { ...EMPTY, ...developer } : EMPTY); }, [open, developer]);

  const save = async () => {
    setSaving(true);
    try {
      const body = { company_name: form.company_name, name: form.name, email: form.email, mobile: form.mobile };
      const saved = developer
        ? await handoverApi(`/developers/${developer.id}`, { method: "PUT", body })
        : await handoverApi(`/sites/${siteId}/developers`, { method: "POST", body });
      toast.success(developer ? "Developer updated" : "Developer added");
      onSaved(saved);
      onOpenChange(false);
    } catch (e) {
      toast.error(e.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="developer-dialog">
        <DialogHeader>
          <DialogTitle>{developer ? "Edit Developer" : "Add Developer"}</DialogTitle>
          <DialogDescription>Entered once for this site, then picked for any dwelling they own.</DialogDescription>
        </DialogHeader>
        <ContactFields value={form} onChange={setForm} withCompany prefix="developer" />
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="developer-cancel-button">Cancel</Button>
          <Button onClick={save} disabled={saving} className="btn-construction" data-testid="developer-save-button">
            {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : "Save Developer"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
